<div class="container-fluid">

  <!-- Employee Form Section (Toggle) -->
  @if (showForm) {
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center" style="background-color: #B71C1C; color: white;">
            <h5 class="mb-0" style="color: white;">
              @if (formMode === 'create') {
                <span>Add New Employee</span>
              }
              @if (formMode === 'edit') {
                <span>Edit Employee</span>
              }
              @if (formMode === 'view') {
                <span>Employee Details</span>
              }
            </h5>
            <button type="button" class="btn btn-sm btn-light" (click)="closeForm()">
              <i class="ri-close-line"></i> Close
            </button>
          </div>
          <div class="card-body">
            @if (formMode !== 'view') {
              <form>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Full Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="employeeForm.fullName" name="fullName" required>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Mobile Number <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="employeeForm.mobileNo" name="mobileNo"  (keypress)="($event.charCode >= 48 && $event.charCode <= 57)" maxlength="10"  pattern="^[6-9][0-9]{9}$"  autocomplete="new-number">
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-md-6 mb-3">
                   <label class="form-label">Email</label>
                    <input type="email" class="form-control" [(ngModel)]="employeeForm.email" name="email">
                  </div> -->
                  <div class="col-md-6 mb-3"  *ngIf="formMode === 'create'" >
                    <label class="form-label">Password <span class="text-danger">*</span></label>
                    <div class="input-group">
                      <input [type]="showPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="employeeForm.password" name="password" autocomplete="new-password" required>
                      <button class="btn btn-light bgn-sm border  text-muted" style="background-color: white;" type="button" 
                              [title]="showPassword ? 'Hide Password' : 'Show Password'" 
                              (click)="showPassword = !showPassword">
                        <i [class]="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'" style="font-size: 14px;"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Firestation <span class="text-danger">*</span></label>
                    <select class="form-select" [(ngModel)]="employeeForm.fireStationId" name="fireStationId" required>
                      <option [value]="undefined">Select Firestation</option>
                      @for (st of fireStation; track st) {
                        <option [value]="st.id">{{st.name}}</option>
                      }
                    </select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Employee Role <span class="text-danger">*</span></label>
                    <select class="form-select" [(ngModel)]="employeeForm.roleId" name="roleId" required>
                      <option [value]="undefined">Select Employee Role</option>
                      @for (role of roles; track role) {
                        <option [value]="role.id">{{role.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                 <!-- <div class="row">
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date of Joining</label>
                    <input type="date" class="form-control" [(ngModel)]="employeeForm.dateOfJoining" name="dateOfJoining">
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-md-3 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="employeeForm.isActive"
                        name="isActive" id="isActive">
                      <label class="form-check-label" for="isActive">Active</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button type="button" class="btn btn-secondary me-2" (click)="closeForm()">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="saveEmployee()">
                      <i class="ri-save-line align-bottom me-1"></i> Save Employee
                    </button>
                  </div>
                </div>
              </form>
            }
            @if (formMode === 'view' && selectedEmployee) {
              <div>
                <div class="row">
                  <!-- <div class="col-md-6 mb-3">
                    <strong>Employee Code:</strong> {{selectedEmployee.code}}
                  </div> -->
                  <div class="col-md-6 mb-3">
                    <strong>Name:</strong> {{getEmployeeName(selectedEmployee)}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <strong>Mobile:</strong> {{selectedEmployee.mobileNo}}
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-md-6 mb-3">
                    <strong>Password:</strong> {{selectedEmployee.password}}
                  </div> -->
                </div>     
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <strong>Firestation:</strong> {{selectedEmployee.fireStation?.name || getFireStationName(selectedEmployee.fireStationId)}} 
                  </div>
                  <div class="col-md-6 mb-3">
                    <strong>Role:</strong> {{ selectedEmployee.role?.name || selectedEmployee.role?.slug || selectedEmployee.role || '-' }}
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-md-6 mb-3">
                    <strong>Date of Joining:</strong> {{selectedEmployee.dateOfJoining || '-'}}
                  </div> -->
                  <div class="col-md-6 mb-3">
                    <strong>Status:</strong>
                    @if (selectedEmployee.isActive) {
                      <span class="badge bg-success">Active</span>
                    }
                    @if (!selectedEmployee.isActive) {
                      <span class="badge bg-danger">Inactive</span>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button type="button" class="btn btn-secondary" (click)="closeForm()">Close</button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Employee List Section -->
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="card-title mb-0" style="color: white;">
              <i class="ri-team-line me-2"></i>Employee Management
            </h5>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm" (click)="clearFilters()" style="background-color: white; color: #B71C1C; border-color: white;">
                <i class="ri-refresh-line align-middle"></i> Refresh
              </button>
              <button type="button" class="btn btn-sm" (click)="openCreateModal()"  *ngIf="!roleService.hasRole(['fire_station'])" style="background-color: white; color: #B71C1C; border-color: white;">
                <i class="ri-add-line align-middle"></i> Add Employee
              </button>
            </div>
          </div>
        </div>

        <div class="card-body">
          <!-- Loading State -->
          @if (loading) {
            <div class="text-center py-4">
              <div class="spinner-border" role="status" style="color: #B71C1C;">
                <span class="visually-hidden">Loading employees...</span>
              </div>
              <p class="mt-2 text-muted">Loading employees...</p>
            </div>
          }

          <!-- Error State -->
          @if (error) {
            <div class="alert alert-danger" role="alert">
              <i class="ri-error-warning-line me-2"></i>
              {{ error }}
            </div>
          }

          <!-- Filters and Table -->
          @if (!loading) {
            <!-- Filters Section -->
            <div class="mb-3">
              <div class="row g-2">
                <!-- Role Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Designation</label>
                  <select class="form-select" name="role_id" [(ngModel)]="filters.role_id">
                    <option value="">All Designations</option>
                    @for (role of roles; track role.id) {
                      <option [value]="role.id">{{role.name}}</option>
                    }
                  </select>
                </div>

                <!-- Fire Station Filter -->
                <div class="col-md-2"  *ngIf="!roleService.hasRole(['fire_station'])">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Fire Station</label>
                  <select class="form-select" name="fire_station_id" [(ngModel)]="filters.fire_station_id">
                    <option value="">All Fire Stations</option>
                    @for (st of fireStation; track st.id) {
                      <option [value]="st.id">{{st.name}}</option>
                    }
                  </select>
                </div>

                <!-- Status Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Status</label>
                  <select class="form-select" [(ngModel)]="filters.is_active">
                    <option value="">All Status</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>

                <!-- Load Button -->
                <div class="col-md-2 d-flex align-items-end">
                  <button type="button" class="btn btn-sm w-100" style="background-color: #B71C1C; color: white;" (click)="applyFilters()">
                    <i class="ri-search-line align-middle"></i> Load
                  </button>
                </div>

                <!-- Reset Button -->
                <div class="col-md-2 d-flex align-items-end">
                  <button type="button" class="btn btn-sm btn-secondary w-100" (click)="clearFilters()">
                    <i class="ri-refresh-line align-middle"></i> Reset
                  </button>
                </div>
              </div>
            </div>

          @if (filteredEmployees.length > 0) {
            <div class="table-responsive">
              <table class="table table-hover align-middle table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <!-- <th>Email</th> -->
                    <th>Firestation</th>
                    <th>Employee Role</th>
                    <!-- <th>Shift</th>
                    <th>Face</th> -->
                    <th>Status</th>
                    <th  *ngIf="!roleService.hasRole(['fire_station'])">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (employee of filteredEmployees; track employee) {
                    <tr>
                      <td>{{employee.id}}</td>
                      <td>{{getEmployeeName(employee)}}</td>
                      <td>{{employee.mobileNo}}</td>
                       <!-- <td>{{employee.password }}</td> -->
                      <td>{{employee.fireStation?.name || getFireStationName(employee.fireStationId)}}</td>
                      <td>{{ employee.role?.name || employee.role?.slug || employee.role || '-' }}</td>
                      <!-- <td>{{employee.shift?.name || getShiftName(employee.shiftId)}}</td> -->
                      <!-- <td>
                        @if (employee.biometricData) {
                          <span class="badge bg-success">
                            <i class="ri-checkbox-circle-line"></i> Registered
                          </span>
                        }
                        @if (!employee.biometricData) {
                          <span class="badge bg-warning">
                            <i class="ri-close-circle-line"></i> Not Registered
                          </span>
                        }
                      </td> -->
                      <td>
                        @if (employee.isActive) {
                          <span class="badge bg-success">Active</span>
                        }
                        @if (!employee.isActive) {
                          <span class="badge bg-danger">Inactive</span>
                        }
                      </td>
                      <td  *ngIf="!roleService.hasRole(['fire_station'])">
                        <div class="d-flex gap-1">
                          <button type="button" class="btn btn-sm btn-soft-info" (click)="openViewModal(employee)" title="View">
                            <i class="ri-eye-line"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary" (click)="openEditModal(employee)" title="Edit">
                            <i class="ri-edit-line"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-danger" (click)="deleteEmployee(employee)" title="Delete">
                            <i class="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (!loading && filteredEmployees.length === 0) {
            <div class="text-center py-5">
              <i class="ri-user-line" style="font-size: 3rem; color: #ccc;"></i>
              <p class="text-muted mt-2">No employees found</p>
            </div>
          }
          }

          
            <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPages > 0">
              <div class="text-muted">
                  Showing {{((currentPage - 1) * perPage) + 1}} to {{Math.min(currentPage * perPage, totalRecords)}} of {{totalRecords}} entries
              </div>
                <nav aria-label="Page navigation" *ngIf="totalPages > 0">
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" [class.disabled]="currentPage === 1">
                      <a class="page-link" (click)="onPageChange(1)" style="cursor: pointer;">
                        <i class="ri-arrow-left-double-line"></i>
                      </a>
                    </li>
                    <li class="page-item" [class.disabled]="currentPage === 1">
                      <a class="page-link" (click)="onPageChange(currentPage - 1)" style="cursor: pointer;">
                        <i class="ri-arrow-left-s-line"></i>
                      </a>
                    </li>
                    <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
                      <a class="page-link" (click)="onPageChange(page)" style="cursor: pointer;">{{ page }}</a>
                    </li>
                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                      <a class="page-link" (click)="onPageChange(currentPage + 1)" style="cursor: pointer;">
                        <i class="ri-arrow-right-s-line"></i>
                      </a>
                    </li>
                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                      <a class="page-link" (click)="onPageChange(totalPages)" style="cursor: pointer;">
                        <i class="ri-arrow-right-double-line"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
            </div>
          
        </div>
      </div>
    </div>
  </div>


<!-- Biometric Modal -->
<!-- <div class="modal fade" [class.show]="showBiometricModal" [style.display]="showBiometricModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Biometric Registration</h5>
        <button type="button" class="btn-close" (click)="closeBiometricModal()"></button>
      </div>
      <div class="modal-body">
        @if (selectedEmployee) {
          <div>
            <h6>Employee: {{getEmployeeName(selectedEmployee)}}</h6>
            <p class="text-muted">Code: {{selectedEmployee.code}}</p>
            @if (biometricData) {
              <div class="mb-3">
                <div class="alert alert-info">
                  <strong>Status:</strong>
                  @if (biometricData.isRegistered) {
                    <span class="badge bg-success ms-2">Registered</span>
                  }
                  @if (!biometricData.isRegistered) {
                    <span class="badge bg-warning ms-2">Not Registered</span>
                  }
                </div>
                @if (biometricData.registrations && biometricData.registrations.length > 0) {
                  <div>
                    <h6>Registered Images:</h6>
                    <div class="row">
                      @for (reg of biometricData.registrations; track reg) {
                        <div class="col-md-6 mb-2">
                          <img [src]="reg.imageUrl" class="img-thumbnail" alt="Face Image">
                          <small class="d-block text-muted">{{reg.registeredAt | date:'short'}}</small>
                        </div>
                      }
                    </div>
                    <button type="button" class="btn btn-danger btn-sm mt-2" (click)="deleteBiometric()">
                      <i class="ri-delete-bin-line"></i> Delete All
                    </button>
                  </div>
                }
              </div>
            }
            <div class="mb-3">
              <label class="form-label">Upload Face Images</label>
              <input type="file" class="form-control" (change)="onFileSelect($event)"
                accept="image/*" multiple>
                <small class="text-muted">You can select multiple images (jpg, jpeg, png, max 10MB each)</small>
              </div>
              @if (selectedFiles.length > 0) {
                <div class="mb-3">
                  <strong>Selected Files:</strong>
                  <ul>
                    @for (file of selectedFiles; track file) {
                      <li>{{file.name}} ({{(file.size / 1024 / 1024).toFixed(2)}} MB)</li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeBiometricModal()">Close</button>
          <button type="button" class="btn btn-primary" (click)="registerBiometric()"
            [disabled]="selectedFiles.length === 0">
          <i class="ri-fingerprint-line"></i> Register
        </button>
      </div>
    </div>
  </div>
</div>

@if (showBiometricModal) {
  <div class="modal-backdrop fade" [class.show]="showBiometricModal"
  ></div>
} -->

